import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Home() {
  useEffect(() => {
    document.title = "Hotel Atlanta | Welcome";
  }, []);

  return (
    <>
      <header>
  <div
    id="showcase"
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL + "/images/showcase.jpg"})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      height: "600px",
      color: "#fff",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div className="container">
      <div className="showcase-content">
        <h1>
          <span className="text-primary"> Enjoy</span> Your Stay
        </h1>
        <p className="lead">
          Looking for a great place to stay with affordable prices? Well look no further — Hotel Atlanta welcomes you.
        </p>
        <Link className="btn" to="/booking">Book Now</Link>
      </div>
    </div>
  </div>
</header>

      <section id="home-info" className="bg-dark">
        <div className="container">
          <div className="info-img">
            <img
              src={process.env.PUBLIC_URL + "/images/photo-1.jpg"}
              alt="Hotel"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
          <div className="info-content">
            <h2><span className="text-primary">The History</span> Of Our Hotel</h2>
            <p>
  Hotel Atlanta was founded in 1953 by Mr. AP Singh, a Gurugram native with a vision for providing good hospitality at affordable prices. We at Hotel Atlanta pride ourselves in honoring the traditions of our founder as well as our culture of <em>vasudhaiva kutumbakam</em>. Over the decades, we have welcomed guests from around the world, offering personalized care and comfort. Our legacy continues through timeless service, serene spaces, and a commitment to making every stay memorable.
</p>
            <Link to="/about" className="read-more-link">Read More</Link>
          </div>
        </div>
      </section>

      <section id="features">
  <Link to="/location-and-amenities" className="box bg-light" style={{ textDecoration: 'none', color: 'inherit' }}>
    <i className="fa-solid fa-hotel fa-3x"></i>
    <h3>Great Location</h3>
          <p>
             Located in Sector 33 near DLF Phase 2 in Gurguram with easy access to transportation and closer to various multinational companies like PWC, Zomato and various others.
          </p>
       </Link>

  <Link to="/location-and-amenities" className="box bg-primary" style={{ textDecoration: 'none', color: 'inherit' }}>
    <i className="fa-solid fa-utensils fa-3x"></i>
    <h3>Free Meals</h3>
          <p>
            At Hotel Atlanta we offer a 24x7 food service with free complimentary breakfast for guests staying at the Hotel.
          </p>
         </Link>

  <Link to="/location-and-amenities" className="box bg-light" style={{ textDecoration: 'none', color: 'inherit' }}>
    <i className="fa-solid fa-dumbbell fa-3x"></i>
    <h3>Fitness Room</h3>
          <p>
            We also pride ourself in providing a robust fitness system with a 24x7 gym, a sauna room, a proffessional masseuse services.
          </p>
        </Link>
</section>

      <div className="clr"></div>
    </>
  );
}

export default Home;